import React from 'react';
import { FaPhone, FaEnvelope, FaGoogle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import logo from '../assets/img/logoPA.png';

const Footer = () => {
  const [t, i18n] = useTranslation("global");
  return (
    <footer id='contact' className='bg-primary text-white font-tertiary shadow-lg py-12 tracking-[2px]'>
      {/* <div className='container mx-auto text-white'>
        DC Executive Homes & Dream Apartments bg-gray-800 bg-accent
      </div> */}
      <div className='mx-auto w-[100px] mb-4'>
        <img src={logo} className='w-[100px] text-center'></img>
      </div>
       {/* Location */}
       <div className="text-center mb-4">
        <p>{t(`homeT.futerTekst2`)}</p>
      </div>

      {/* Get in Touch */}
      <div className="text-center mb-4">
        <h2 className="text-lg font-bold">{t(`homeT.futerTekst`)}</h2>
      </div>

      {/* Contact Icons */}
      <div className="flex flex-col md:flex-row justify-center items-center mb-4">
      <div className="flex items-center mr-4 mb-4 md:mb-0">
          <FaPhone className="mr-2" />
          <span>Phone: <a href="tel:+381658079191">+381 65 807/9191</a></span>
        </div>
      <div className="flex items-center mr-4 mb-4 md:mb-0">
          <FaPhone className="mr-2" />
          <span>Phone: <a href="tel:+381646106752">+381 64 610/6752</a></span>
        </div>
        <div className="flex items-center mr-4 mb-4 md:mb-0">
          <FaEnvelope className="mr-2" />
          <span>Email: <a href="mailto:ivan.popadic@gmail.com">ivan.popadic@gmail.com</a></span>
        </div>
        {/* <div className="flex items-center">
          <FaGoogle className="mr-2" />
          <span>Google: example@gmail.com</span>
        </div> */}
      </div>

      {/* Divider Line border-gray-600*/}
      <hr className="my-4 w-1/2 mx-auto border-white" />

      {/* Email */}
      <div className="text-center">
        <p>Made By: <a href="https://www.instagram.com/webips.digital?igsh=eHlyNzBxZHBmeDF2" target="_blank" class="linkWebips">webips.digital</a> | Email: <a href={`mailto:webips.pro@gmail.com`}>webips.pro@gmail.com</a></p>
      </div>

    </footer>
  );
};

export default Footer;
